import React from 'react'
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import Cart from '../components/cart/Cart';

export default function CartPage() {
  return (
    <>
        <Navbar></Navbar>
        <Cart></Cart>
        <Footer></Footer>
    </>
  )
}
